import React, { useState } from "react";
import BookingFinanceSearch from "./BookingFinanceSearch/BookingFinanceSearch";
import BookingScheduleSearch from "./BookingScheduleSearch/BookingScheduleSearch";
import BookingAuditSearch from "@bookings/BookingSearch/BookingAuditSearch/BookingAuditSearch";
import { BookingSyncReport } from "./BookingSyncReport/BookingSyncReport";
import { BookingFilterGroup } from "./utils";

type Props = {
  onOpen: (id: string, tab?: string, scrollContainer?: HTMLElement) => void;
  onEdit: (id?: string) => void;
};

export const BookingSearch = ({ onOpen, onEdit }: Props) => {
  const [groupBy, onGroupBy] = useState<BookingFilterGroup>(BookingFilterGroup.Finance);

  const props = { onOpen, onGroupBy, onEdit };

  switch (groupBy) {
    case BookingFilterGroup.Finance:
      return <BookingFinanceSearch {...props} />;

    case BookingFilterGroup.Schedule:
      return <BookingScheduleSearch {...props} />;

    case BookingFilterGroup.Sync:
      return <BookingSyncReport {...props} />;

    case BookingFilterGroup.Audit:
      return <BookingAuditSearch {...props} />;

    // case BookingFilterGroup.KitSupport:
    //   return <TimereportKitSupportSearch {...props} />;

    default:
      console.error(new Error("not found"));
      return null;
  }
};
